<link *ngIf="branding == '602'" href="https://fonts.googleapis.com/css2?family=Overpass:wght@400;700&display=swap"
    rel="stylesheet">

<main [attr.data-branding]="'customer-' + branding" [class]="chargingStation?.lat && chargingStation?.lon ? 'map' : ''">
    <div class="branding">
        <div class="py-4"><app-svg *ngIf="branding == '602'" source="es-tec" height="60" width="auto"></app-svg></div>
    </div>

    <div *ngIf="chargingStation?.lat && chargingStation?.lon" leaflet id="map" [leafletOptions]="mapOptions"
        (leafletMapReady)="onMapReady($event)">
    </div>

    <!-- Awaits validation -->
    <div class="wrapper" *ngIf="publicTransactionSession == null">
        <div class="card">
            <div class="icon"><app-svg source="icons/feather/loader" class="loading" height="40"></app-svg></div>
            <h2 i18n="@@WaitForChargingPointInfoHeader">Warte auf Ladepunkt</h2>
        </div>
    </div>
    
    <!-- Validation successful -->
    <div class="wrapper" *ngIf="publicTransactionSession">
        <!-- 2: Available (Bereit) -->
        <!-- or 6: Preparing (Bereit) but EV is not connected -->
        <!-- TODO: check isNeedingRestart to show timeout -->
        <div class="card" *ngIf="publicTransactionSession.stopTimestamp == null && publicTransactionSession.chargingStationStatusId == 2 || publicTransactionSession.stopTimestamp == null && publicTransactionSession.chargingStationStatusId == 6 && !isEvConnected">
            <div class="icon">
                <app-svg source="icons/feather/charging-station" height="40"></app-svg>
                <app-svg source="icons/feather/arrow-right" height="40"></app-svg>
                <app-svg source="icons/feather/car" height="40"></app-svg>
            </div>
            <h2 i18n="@@ConnectVehicleText">Bitte verbinden Sie den Ladepunkt mit Ihrem Fahrzeug</h2>
        </div>

        <!-- 6: Preparing (Vorbereitung und Fahrzeug verbunden) -->
        <div class="card" *ngIf="publicTransactionSession.stopTimestamp == null && publicTransactionSession.chargingStationStatusId == 6 && isEvConnected">
            <div *ngIf="!isNeedingRestart">
                <div class="icon"><app-svg source="icons/feather/clock" height="40"></app-svg></div>
                <h2 i18n="@@TransactionStartText">Ladevorgang wird gestartet</h2>
            </div>

            <div *ngIf="isNeedingRestart">
                <div class="icon"><app-svg source="icons/feather/check-circle" height="40"></app-svg></div>
                <h2 i18n="@@TransactionStartText">Ladepunkt und Fahrzeug sind bereit</h2>
                <br />
                <a class="button hero" (click)="startTransaction()">Ladevorgang starten</a>
            </div>
        </div>
        
        <!-- 3: Charging (Lädt) -->
        <div class="card" *ngIf="publicTransactionSession.stopTimestamp == null && publicTransactionSession.chargingStationStatusId == 3">
            <div class="icon glow">
                <app-svg source="icons/feather/zap" height="40" *ngIf="!isFinishing"></app-svg>
                <app-svg source="icons/feather/loader" class="loading" height="40" *ngIf="isFinishing"></app-svg>
            </div>
            <h2 i18n="@@TransactionInProgressText" *ngIf="!isFinishing">Ladevorgang läuft</h2>
            <h2 i18n="@@TransactionIsFinishingText" *ngIf="isFinishing">Beende Ladevorgang</h2>
            
            <span class="timer" *ngIf="publicTransactionSession.startTimestamp">
                <strong>{{ duration }}</strong>
                <small i18n="@@TransactionStartFromText">seit {{ publicTransactionSession.startTimestamp | date:'HH:mm' }} Uhr</small>
            </span>
            <span class="timer" *ngIf="!publicTransactionSession.startTimestamp">
                <strong>&ndash;&ndash;:&ndash;&ndash;</strong>
                <small i18n="@@TransactionStartFromText">seit &ndash;&ndash;:&ndash;&ndash;</small>
            </span>

            <span class="meter" *ngIf="kwhCharged">
                <strong>{{ kwhCharged | number:'1.3':'de' }}&nbsp;kWh</strong>
                <span>für {{ price | number:'1.2-2':'de' }}&nbsp;€</span>
                <span *ngIf="publicTransactionSession.expectedTotalChargeAmount" style="line-height: 1;">
                    begrenzt auf {{ publicTransactionSession.expectedTotalChargeAmount / 100 | number:'1.2-2' }}&nbsp;€
                    ({{ (price / (publicTransactionSession.expectedTotalChargeAmount / 100)) * 100 | number:'1.0-0':'de' }}%)
                </span>
            </span>
            <span class="meter" *ngIf="!kwhCharged">
                <strong>&ndash;,&ndash;&ndash;&ndash;&nbsp;kWh</strong>
                <span>für &ndash;,&ndash;&ndash;&nbsp;€</span>
            </span>

            <br />
            <ng-container *ngTemplateOutlet="buttonStop"></ng-container>
        </div>
        
        <!-- 8: SuspendedEV (Pausiert durch Fahrzeug) -->
        <div class="card" *ngIf="publicTransactionSession.stopTimestamp == null && publicTransactionSession.chargingStationStatusId == 8">
            <div class="icon glow"><app-svg source="icons/feather/pause-circle" height="40"></app-svg></div>
            <h2 i18n="@@TransactionInProgressText">Ladevorgang pausiert durch Fahrzeug</h2>
            <p>Das Fahrzeug ist voll.</p>
            <ng-container *ngTemplateOutlet="buttonStop"></ng-container>
        </div>
        
        <!-- 9: SuspendedEVSE (Pausiert durch Ladestation) -->
        <div class="card" *ngIf="publicTransactionSession.stopTimestamp == null && publicTransactionSession.chargingStationStatusId == 9">
            <div class="icon glow"><app-svg source="icons/feather/pause-circle" height="40"></app-svg></div>
            <h2 i18n="@@TransactionInProgressText">Ladevorgang pausiert durch Ladestation</h2>
            <p>Warten auf Freigabe durch Lastmanagement. Der Ladevorgang beginnt in wenigen Augenblicken.</p>
            <ng-container *ngTemplateOutlet="buttonStop"></ng-container>
        </div>
        
        <!-- 5: Finishing -->
        <div class="card" *ngIf="publicTransactionSession.stopTimestamp != null">
            <div class="icon glow"><app-svg source="icons/feather/check-circle" height="40"></app-svg></div>
            <h2 i18n="@@TransactionEndSuccessText">Ladevorgang beendet</h2>
            <span class="charge" *ngIf="kwhCharged != null">
                <strong>{{ kwhCharged | number:'1.3-3':'de' }}&nbsp;kWh</strong>
                <small i18n="@@TransactionAmountText">geladen {{ duration ? 'in ' + duration : '' }}</small>
            </span>
            <span class="bill" *ngIf="pricing != null">
                <strong>{{ (price > 1 ? price : 1) | number:'1.2-2':'de' }}&thinsp;€</strong>
                <small i18n="@@TransactionPriceText">inkl. MwSt.</small>
            </span>
            <br />
            <p style="font-size: 1.5rem;" i18n="@@TransactionEndFarewellText">Wir wünschen eine gute Weiterfahrt.</p>
        </div>

        <p *ngIf="chargingStation.customer"  i18n="@@ChargingPointElectricityProviderInfoText">
          Ladepunkt und Strom werden bereitgestellt von <a *ngIf="parkOwner && parkOwner.email else company" [href]="'https://www.'+parkOwner.email.split('@')[1]" target="_blank">{{ chargingStation.customer.name }}</a>.
          <ng-template #company>{{ chargingStation.customer.name }}</ng-template>
        </p>
        <p>
          <img src="assets/favicon-32x32.png" alt="CUBOS" />
          <a href="https://www.cubos.com" target="_blank"><strong>Powered by CUBOS</strong></a>
          <span>&copy; Copyright&nbsp;{{ getFullYear() }} CUBOS&nbsp;Service&nbsp;GmbH. Alle Rechte vorbehalten.</span>
        </p>
    </div>
</main>

<ng-template #buttonStop>
    <a *ngIf="!isFinishing" class="button hero" (click)="stopCharging()" i18n="@@TransactionButtonEnd">Ladevorgang beenden</a>
    <a *ngIf="isFinishing" class="button hero pr-5" disabled i18n="@@TransactionButtonEnding">
        Beende Ladevorgang
        <app-svg source="icons/feather/loader" class="rotating absolute ms-2" height="24"></app-svg>
    </a>
</ng-template>
